<template>
    <transition name="modal-custom-fade">
        <div class="page-slide-modal">
            <div class="modal-backdrop" @click="closeByBackdrop">
                <div class="modal-content overflow-hidden relative">
                    <InnerLoader v-if="isLoading" />

                    <div class="close cursor-pointer" @click="closeModal">
                        <i class="fas fa-times text-xl shadow-text-none"></i>
                    </div>

                    <div class="modal-body h-full">
                        <swiper
                            @slideChange="onChangeSwiper"
                            :options="swiperOptions"
                            class="w-full h-full"
                            ref="mySwiper"
                        >
                            <swiper-slide
                                v-for="(slide, slideIndex) in slides"
                                :key="`slide-${slideIndex}`"
                                :id="`slide-${slideIndex}`"
                                class="slide-container w-full"
                            >
                                <div
                                    v-if="!slide.is_video_upload"
                                    :style="{
                                        backgroundImage: `url(${
                                            slide.image.length > 0 ? slide.image : require('@/assets/no-image.jpg')
                                        })`
                                    }"
                                    class="slide-image"
                                ></div>
                                <div
                                    v-else
                                    :style="{
                                        backgroundImage: `url(${setSlideVideoBackground(slide)})`
                                    }"
                                    class="slide-video"
                                >
                                    <div
                                        v-if="slide.is_video_upload && slide.image && isVideoYouTube(slide)"
                                        :style="{
                                            backgroundImage: `url(${slide.image})`
                                        }"
                                        class="bg-video"
                                    ></div>
                                    <video-player
                                        v-if="slide.video"
                                        :ref="`videoPlayer${slideIndex}`"
                                        :class="{
                                            'w-full h-full': true,
                                            'youtube-player':
                                                slide.is_video_upload && slide.image && isVideoYouTube(slide)
                                        }"
                                        :video-meta="getVideoMeta(slide)"
                                        :video-path="getVideoMeta(slide).video"
                                        :time-duration="slide.video_time"
                                    >
                                    </video-player>
                                </div>
                                <div class="slide-content">
                                    <div
                                        v-html="slide.content"
                                        class="px-3 lg:px-8 lg:flex lg:flex-col lg:justify-center"
                                        style="min-height: 100%"
                                    ></div>
                                </div>
                            </swiper-slide>
                            <div class="swiper-pagination" slot="pagination"></div>
                            <div
                                v-show="slides.length > 1"
                                class="swiper-button-prev swiper-button-black"
                                slot="button-prev"
                            ></div>
                            <div
                                v-show="slides.length > 1"
                                class="swiper-button-next swiper-button-black"
                                slot="button-next"
                            ></div>
                        </swiper>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import InnerLoader from '@/components/InnerLoader'
import Request from '@/lib/request.js'
import appConfig from '@/app.config.js'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import VideoPlayer from '../../../frontend/src/components/VideoPlayer.vue'

export default {
    name: 'PageSliderPopup',

    components: {
        InnerLoader,
        swiper,
        swiperSlide,
        VideoPlayer
    },

    props: {
        pageSliderSlug: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            isLoading: true,
            slides: [],

            swiperOptions: {
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            }
        }
    },

    mounted() {
        this.fetchData()
        document.addEventListener(
            'click',
            function (el) {
                let tag = el.target.nodeName
                let tagId = el.target.hash
                if (tag == 'A' && tagId.includes('#slide')) {
                    el.preventDefault()
                    let splitId = tagId.split('-')
                    this.$refs.mySwiper.swiper.slideTo(+splitId[1] - 1, 500, false) // splitId(Array(start0)) - 1
                }
            }.bind(this)
        )
    },

    methods: {
        fetchData() {
            const request = new Request()
            const url = appConfig.api.fetchPageBySlug

            request
                .get(url, {
                    params: {
                        slug: this.pageSliderSlug
                    }
                })
                .then(res => {
                    let data = res.data.data
                    let slides = data.slides

                    this.slides = slides
                    this.isLoading = false

                    if (slides[0].is_video_upload) {
                        this.$nextTick(() => {
                            setTimeout(() => {
                                if (this.$refs[`videoPlayer0`]) {
                                    this.$refs[`videoPlayer0`][0].player.play()
                                    this.$refs[`videoPlayer0`][0].setMuted(slides[0].video_mute)
                                }
                            }, 800)
                        })
                    }
                })
                .catch(() => {
                    this.closeModal()
                })
        },

        closeByBackdrop(e) {
            if (!e.target.classList.contains('modal-backdrop')) {
                return
            }

            this.$emit('close')
        },

        closeModal() {
            this.$emit('close')
        },

        getVideoMeta(slide) {
            return {
                video: slide.video,
                video_loop: slide.video_loop,
                video_mute: slide.video_mute
            }
        },

        onChangeSwiper() {
            const index = this.$refs.mySwiper.swiper.activeIndex

            for (let ref in this.$refs) {
                if (ref.indexOf('videoPlayer') > -1) {
                    this.$refs[ref][0].player.pause()
                }
            }

            const mute = this.slides[index].video_mute

            if (this.$refs[`videoPlayer${index}`]) {
                this.$nextTick(() => {
                    this.$refs[`videoPlayer${index}`][0].player.play()
                    this.$refs[`videoPlayer${index}`][0].setMuted(mute)
                })
            }
        },

        setSlideVideoBackground(slide) {
            if (!this.isVideoYouTube(slide) && slide.video) {
                return slide.video_thumbnail
            }

            if (!slide.video) {
                return require('@/assets/no-image.jpg')
            }

            if (this.isVideoYouTube(slide)) {
                return ''
            }
        },

        isVideoYouTube(slide) {
            if (slide.video == null || !slide.video) {
                return false
            }

            return slide.video.indexOf('http') == -1
        }
    }
}
</script>

<style lang="scss">
@import '~vue-plyr/dist/vue-plyr.css';

$gap-modal: 10%;

@mixin max-lg() {
    @media (max-width: 991px) {
        @content;
    }
}

.modal-custom-fade-enter-active {
    transition: opacity 0.5s;
}
.modal-custom-fade-enter, .modal-custom-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}

.page-slide-modal {
    z-index: 999;

    .modal-backdrop {
        background-color: rgba(0, 0, 0, 0.2);
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: start;
        z-index: 100000;
        overflow: auto;

        .modal-content {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background-color: white;
            width: calc(100% - #{$gap-modal});
            height: calc(100% - #{$gap-modal});
            border-radius: 0.5rem;
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);

            @include max-lg() {
                $gap-modal: 1.5rem;

                width: calc(100% - #{$gap-modal});
                height: calc(100% - #{$gap-modal});

                .swiper-button-prev,
                .swiper-button-next {
                    display: none;
                }
            }

            .close {
                background-color: #00000063;
                color: #fff;
                position: absolute;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 28px;
                height: 28px;
                right: 0.75rem;
                top: 0.75rem;
                border-radius: 50%;
                z-index: 999;
            }

            .modal-body {
                margin: 0;
            }
        }

        .slide-container {
            display: flex;

            @include max-lg() {
                flex-direction: column;
            }
        }

        .slide-image {
            flex: 1;
            width: 100%;
            height: 100%;
            background-position: center;
            background-size: cover;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 30%;
                background-image: linear-gradient(
                    to Top,
                    rgba(255, 255, 255, 0.2) 0%,
                    rgba(255, 255, 255, 0.1) 20%,
                    rgba(255, 255, 255, 0) 50%
                );
            }
        }

        .slide-video {
            flex: 1;
            width: 100%;
            height: 100%;
            background-position: center;
            background-size: cover;
            position: relative;

            .plyr__controls {
                opacity: 0;
                pointer-events: none;
            }

            #video-block {
                width: 100%;
                object-fit: cover;
                object-position: center center;
            }
        }

        .bg-video {
            width: 100%;
            height: 100%;
            background-position: center;
            background-size: cover;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 0;
        }

        .bg-video::after {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            backdrop-filter: blur(4px);
        }

        .youtube-player {
            .plyr--video {
                height: auto;
                width: 100%;
            }

            .video-container {
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }

        .slide-content {
            flex: 1;
            overflow-x: auto;
            height: calc(100% - 2.75rem);

            @include max-lg() {
                height: auto;
            }

            * {
                text-shadow: none;
            }

            h1 {
                font-size: 2.5rem;

                @include max-lg() {
                    font-size: 2rem;
                }
            }

            h2 {
                font-size: 2rem;

                @include max-lg() {
                    font-size: 1.75rem;
                }
            }

            h3 {
                font-size: 1.75rem;

                @include max-lg() {
                    font-size: 1.5rem;
                }
            }

            a {
                color: black;
                transition: opacity 0.3s;
                will-change: opacity;

                &:hover {
                    opacity: 0.6;
                }
            }

            blockquote {
                border-left: 0.7rem solid #000;
                margin: 1.5em 0.7rem;
                padding: 0.5em 0.7rem;
            }

            .ql-align-center {
                text-align: center;
            }
            .ql-align-right {
                text-align: right;
            }
            .ql-align-justify {
                text-align: justify;
            }

            .ql-video {
                &.ql-align-center {
                    margin: 0 auto;
                    display: block;
                }
                &.ql-align-right {
                    margin-left: auto;
                    display: block;
                }
            }

            .img-fluid {
                max-width: 100%;
                cursor: default !important;
            }

            img,
            .ql-video {
                max-width: 100%;
            }
        }
    }

    .swiper-pagination-bullet {
        background: #fff;
    }

    .swiper-pagination-bullet-active {
        background: #fff;
    }

    .swiper-button-prev,
    .swiper-button-next {
        display: block;
    }

    .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
        margin: 1px 4px;
    }

    .swiper-container {
        display: flex;
        justify-content: center;

        .swiper-pagination {
            background-color: #00000063;
            border-radius: 10px;
            padding: 3px 10px 3px 10px;
            width: unset;
            left: unset;
        }
    }
}
</style>
